export const RadnoVrijemeGpsEvdManagerResourceBS: RadnoVrijemeGpsEvdManagerInterface = {
  title: "Pregled radnog vremena sa GPS lokacijom - Menadžer",
  description:
    "Odaberite zaposlenog iz vaših poslovnica da biste vidjeli njegove evidencije radnog vremena sa GPS lokacijom.",
  selectEmployee: {
    label: "Odaberite zaposlenog",
    placeholder: "Odaberite zaposlenog",
    notFound: "Nema dostupnih zaposlenih",
    showAll: "Prikaži sve",
  },
  inputFields: {
    startDate: {
      label: "Početni datum",
    },
    endDate: {
      label: "Krajnji datum",
    },
  },
  errors: {
    errorLoading:
      "Došlo je do greške tokom učitavanja evidencije radnog vremena sa GPS lokacijom. Molimo kontaktirajte administratora.",
    errorLoadingUsers:
      "Došlo je do greške tokom učitavanja zaposlenih. Molimo kontaktirajte administratora.",
    noManagerAccess:
      "Nemate pristup ovoj stranici. Morate biti postavljeni kao menadžer u konfiguraciji evidencije.",
  },
  timestampLabel: "Vrijeme:",
  locationLabel: "Lokacija:",
  noLocation: "Lokacija nije dostupna",
  noEntries: "Nema evidencija za odabrani period",
  employeeName: "Zaposleni:",
  showTodayButton: "Prikaži danas",
  openMap: "Otvori mapu",
};

export const RadnoVrijemeGpsEvdManagerResourceEN: RadnoVrijemeGpsEvdManagerInterface = {
  title: "Working Time with GPS Location Review - Manager",
  description:
    "Select an employee from your branches to view their working time evidence with GPS location.",
  selectEmployee: {
    label: "Select employee",
    placeholder: "Select employee",
    notFound: "No employees available",
    showAll: "Show all",
  },
  inputFields: {
    startDate: {
      label: "Start date",
    },
    endDate: {
      label: "End date",
    },
  },
  errors: {
    errorLoading:
      "An error occurred while loading working time evidence with GPS location. Please contact the administrator.",
    errorLoadingUsers:
      "An error occurred while loading employees. Please contact the administrator.",
    noManagerAccess:
      "You do not have access to this page. You must be set as a manager in the evidence configuration.",
  },
  timestampLabel: "Timestamp:",
  locationLabel: "Location:",
  noLocation: "Location not available",
  noEntries: "No entries for the selected period",
  employeeName: "Employee:",
  showTodayButton: "Show today",
  openMap: "Open map",
};

export const RadnoVrijemeGpsEvdManagerResourceDE: RadnoVrijemeGpsEvdManagerInterface = {
  title: "Arbeitszeit mit GPS-Standort Übersicht - Manager",
  description:
    "Wählen Sie einen Mitarbeiter aus Ihren Filialen aus, um dessen Arbeitszeitnachweise mit GPS-Standort anzuzeigen.",
  selectEmployee: {
    label: "Mitarbeiter auswählen",
    placeholder: "Mitarbeiter auswählen",
    notFound: "Keine Mitarbeiter verfügbar",
    showAll: "Alle anzeigen",
  },
  inputFields: {
    startDate: {
      label: "Startdatum",
    },
    endDate: {
      label: "Enddatum",
    },
  },
  errors: {
    errorLoading:
      "Beim Laden der Arbeitszeitnachweise mit GPS-Standort ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    errorLoadingUsers:
      "Beim Laden der Mitarbeiter ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    noManagerAccess:
      "Sie haben keinen Zugriff auf diese Seite. Sie müssen als Manager in der Evidenzkonfiguration festgelegt werden.",
  },
  timestampLabel: "Zeitstempel:",
  locationLabel: "Standort:",
  noLocation: "Standort nicht verfügbar",
  noEntries: "Keine Einträge für den ausgewählten Zeitraum",
  employeeName: "Mitarbeiter:",
  showTodayButton: "Heute anzeigen",
  openMap: "Karte öffnen",
};

export interface RadnoVrijemeGpsEvdManagerInterface {
  title: string;
  description: string;
  selectEmployee: {
    label: string;
    placeholder: string;
    notFound: string;
    showAll: string;
  };
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
  };
  errors: {
    errorLoading: string;
    errorLoadingUsers: string;
    noManagerAccess: string;
  };
  timestampLabel: string;
  locationLabel: string;
  noLocation: string;
  noEntries: string;
  employeeName: string;
  showTodayButton: string;
  openMap: string;
}

